<template>
  <b-modal
    id="lm-create-segment-modal"
    ref="lmCreateSegmentModal"
    :title="$t(title)"
    :ok-title="$t('Save')"
    ok-variant="primary"
    :cancel-title="formSucess ? $t('close') : $t('Cancel') "
    cancel-variant="secondary"
    :ok-disabled="!!formSucess"
    @ok="submit"
    @cancel="close"
    @close="close"
    @hidden="close"
    >
    <form
      id="lm-create-segment-modal-form"
      novalidate
      class="position-relative"
      @submit.prevent
      v-if="!formSucess"
    >
      <LmTextInput
        id="inputTitle"
        v-model="form.title"
        :v="customValidation"
        :label="$t('title')"
        :placeholder="$t('title')"
        ref="inputTitle"
      />
    </form>
    <p v-if="formError" class="text-danger">{{formError}}</p>
    <h4 v-if="formSucess" class="text-success">{{formSucess}}</h4>
    <LmComponentLoading v-if="isProcessing" />
  </b-modal>
</template>

<script>
import axios from 'axios'

import LmForm from '@/components/form/LmForm.vue'
import LmTextInput from '@/components/form/elements/LmTextInput'
import store from '@/store'

export default {
  data () {
    return {
      form: {
        title: ''
      },
      validate: false,
      isProcessing: false,
      initialForm: {},
      formError: '',
      formSucess: ''
    }
  },
  props: {
    afterCreateSegmentRedirectPath: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'segment_header'
    },
    apiEndpoint: {
      type: String,
      required: true
    },
    fullFrontEndUrl: {
      type: String,
      default: ''
    },
    onSuccessDestinationRoute: {
      type: String,
      default: '/'
    },
    hash: {
      type: String,
      default: ''
    },
    pathUrlToSendData: {
      type: String,
      default: 'segmentador/new/'
    }
  },
  computed: {
    customValidation () {
      return {
        required: false,
        $error: !this.form.title && this.validate
      }
    }
  },
  components: {
    LmForm,
    LmTextInput
  },
  methods: {
    lmShow () {
      this.$refs['lmCreateSegmentModal'].show()
      setTimeout(() => {
        this.$refs.inputTitle.$refs.lmTextInput.focus()
      }, 100)
    },
    async submit (bvModalEvt) {
      bvModalEvt.preventDefault()
      try {
        this.isProcessing = true
        this.validate = true
        if (this.customValidation.$error === false) {
          const dataToSendToTheServer = {
            d_titulo: this.form.title,
            d_api_endpoint: process.env.VUE_APP_API_URL + this.apiEndpoint,
            d_url_path: this.fullFrontEndUrl,
            q_matchargs: this.hash
          }
          const response = await axios.post(
            `${process.env.VUE_APP_API_URL}${this.pathUrlToSendData}`,
            dataToSendToTheServer,
            {
              headers: {
                Authorization: `Bearer ${store.state.session.accessToken}`
              }
            }
          )
          this.formSucess = response.data.message
          this.formError = ''
          this.form = JSON.parse(this.initialForm)
          this.validate = false
          this.$router.push(this.afterCreateSegmentRedirectPath || process.env.VUE_APP_AFTER_CREATE_SEGMENT_REDIRECT_APTH)
        }
      } catch (error) {
        console.log(error)
        this.formError = error
      } finally {
        this.isProcessing = false
      }
    },
    close () {
      this.formError = ''
      this.formSucess = ''
      this.validate = false
      this.form = JSON.parse(this.initialForm)
    }
  },
  created () {
    this.initialForm = JSON.stringify(this.form)
  }
}
</script>
